import { Stack, FlexboxGrid, Col } from 'rsuite';
import classNames from 'classnames';
import { HomeElms, server } from '../config/const';
import { useAppSelector } from '@monorepo/shared';
import {
  Brand,
  OUTree,
  NoticeSpeaker,
  UserProfile,
  ServiceDropdown,
  SupportDropdown
} from '@monorepo/shared/components';
import { cloudLog } from '../pages/Home/homeCons';
import { useGetCommonDataQuery } from '@monorepo/shared/services/globalApi';
import { isExpanded } from '@monorepo/shared/store/sidemenuSlice';
import { useLocation } from 'react-router-dom';
import { CSSProperties } from 'react';
import { selectNotices } from '@monorepo/shared/store/authSlice';
import {
  selectCurrentAccount,
  selectLoginSaml
} from '@monorepo/shared/store/accountSlice';
import { selectOU } from '@monorepo/shared/store/fcOuSlice';
interface IProps {
  hideSideMenu?: boolean;
  style?: CSSProperties;
}

const Header = ({ hideSideMenu, style }: IProps) => {
  const { pathname } = useLocation();
  const loginSaml = useAppSelector(selectLoginSaml);
  const ouData = useAppSelector(selectOU);
  const notices = useAppSelector(selectNotices);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const commonData = useGetCommonDataQuery({ server: server });
  const menuExpanded = useAppSelector(isExpanded);
  const logoIcon = (
    <img
      src={cloudLog}
      width="30px"
      style={{ filter: 'invert(1)', marginRight: '4px' }}
    ></img>
  );
  const logoClasses = classNames('left-container', {
    expand: menuExpanded
  });

  return (
    <FlexboxGrid className="frame-header" justify="space-between" style={style}>
      <FlexboxGrid.Item className={logoClasses}>
        <Stack
          alignItems="center"
          style={{ height: '100%', marginLeft: '10px' }}
          spacing={60}
        >
          <Brand
            logo={logoIcon}
            title={HomeElms.name}
            isExpanded={true}
            // subtitle={'Cloud'}
            titleStyle={{
              fontWight: 'blod',
              fontSize: '1.1rem',
              color: '#212121'
            }}
            subTitleStyle={{
              fontWight: 'blod',
              fontSize: '1.1rem',
              paddingLeft: '8px',
              color: '#212121'
            }}
          />
          {currentAccount?.portals?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <ServiceDropdown
              commonData={commonData?.data}
              account={currentAccount}
            />
          )}
          {currentAccount?.support_menu?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <SupportDropdown
              commonData={commonData?.data}
              account={currentAccount}
            />
          )}
        </Stack>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as={Col}
        md={4}
        ms={4}
        xs={4}
        className="right-container"
      >
        <Stack
          spacing={20}
          justifyContent="flex-end"
          style={{ height: '100%' }}
        >
          <NoticeSpeaker notices={notices} />
          {!pathname.includes('cred') &&
          ouData?.length &&
          currentAccount?.permission_scope?.node_type !== 'Account' ? (
            <OUTree hasPermissionScope isNewPortal />
          ) : (
            <></>
          )}
          <UserProfile
            account={currentAccount}
            commonData={commonData?.data}
            isNewPortal={true}
            loginSaml={loginSaml}
          />
        </Stack>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default Header;
